import PropTypes from "prop-types";
import { useState } from "react";

// Third party
import { findLast } from "lodash-es";

// Helpers
import { getDepartmentalPosition } from "@/Common/helpers/Positions";

// PDF's
import PdfPayPlanLayer from "@/PayPlans/views/Layers/Html/Sales/Associates";

// Layouts
import GeneralDialog from "@/Layouts/components/Dialogs/GeneralDialog";
import RoundedBox from "@/Layouts/components/Basics/RoundedBox";

// Custom Components
import ApprovedMessageLabel from "./ApprovedMessageLabel";
import DisplayPayPlanInfo from "./DisplayPayPlanInfo";
import ReviewAndSignButton from "./ReviewAndSignButton";

// MUI
import { Grid, Stack } from "@mui/material";

const componentToShow = (payPlanAssignment, payPlan, onClick) => {
	const upcomingPayPlanAssignment = { ...(payPlanAssignment?.[0] || {}) };
	let componentToReturn = null;

	const acknowledgementStatus = upcomingPayPlanAssignment?.acknowledgementStatus || [];
	const signingStatus = findLast(acknowledgementStatus, { status: "INPROGRESS" });

	let hasAssigneeSigned = false;
	if (signingStatus?.signingProgress?.length) {
		hasAssigneeSigned = signingStatus.signingProgress?.some((status) => status?.roleId === "assignee" && Boolean(status?.signedAt));
	}

	if (upcomingPayPlanAssignment?.planId?.name === payPlan?.title) {
		componentToReturn = <ReviewAndSignButton onClick={onClick} text={`Review${hasAssigneeSigned ? "" : " and Sign"} `} />;

		if (acknowledgementStatus?.[acknowledgementStatus?.length - 1]?.status === "COMPLETED") {
			const pdfCompletionDate = acknowledgementStatus?.[acknowledgementStatus?.length - 1]?.statusDate;
			componentToReturn = (
				<Stack direction="row" alignItems={"center"} spacing={3}>
					<ApprovedMessageLabel pdfCompletionDate={pdfCompletionDate} />
					<ReviewAndSignButton onClick={onClick} text="Review" />
				</Stack>
			);
		}
	}
	return componentToReturn;
};

function RenderPayPlanPDF(props) {
	const { position = "", selected = null, loading = false, isMyPayPlan = false } = props;
	return <PdfPayPlanLayer selected={selected} loading={loading} isMyPayPlan={isMyPayPlan} />;
}
RenderPayPlanPDF.propTypes = {
	position: PropTypes.string,
	selected: PropTypes.object,
	loading: PropTypes.bool,
	isMyPayPlan: PropTypes.bool,
};

export default function MyPayPlans(props) {
	const { position = "", selected = null, treeData = [], loading = false } = props;
	const embeddedLink = treeData?.[0]?.embeddedSigningLinks?.find((element) => element?.role === "assignee")?.url;

	const [open, setOpen] = useState(false);

	const handleSignPayPlan = () => {
		setOpen(true);
	};

	const handleCloseDialog = () => {
		setOpen(false);
	};

	const newPosition = getDepartmentalPosition(position);
	return (
		<RoundedBox>
			<Grid container margin={"30px"}>
				<DisplayPayPlanInfo
					name={selected.title}
					payPlanData={selected}
					loading={loading}
					payPlanAction={componentToShow(treeData, selected, handleSignPayPlan)}
					position={newPosition}
				/>

				<GeneralDialog onClose={handleCloseDialog} open={open}>
					<iframe src={embeddedLink} title="Embedded Pay Plan" className={"embedded-iframe"} />
				</GeneralDialog>

				<RenderPayPlanPDF position={newPosition} selected={selected} isMyPayPlan={true} />
			</Grid>
		</RoundedBox>
	);
}
MyPayPlans.propTypes = {
	position: PropTypes.string,
	selected: PropTypes.shape({
		_id: PropTypes.string,
		title: PropTypes.string,
	}),
	loading: PropTypes.bool,
	treeData: PropTypes.array,
};
